import { api } from './client'

/**
 * База знаний.
 *
 * Пути повторяют роутер knowledge.py: пространства и статьи под /kb,
 * управление группами — под /admin/kb (глобальный админ).
 */
export const kbApi = {
  // Пространства
  spaces: () => api.get('/kb/spaces'),
  createSpace: (data) => api.post('/kb/spaces', data),
  updateSpace: (key, data) => api.patch(`/kb/spaces/${key}`, data),
  tree: (key) => api.get(`/kb/spaces/${key}/tree`),

  // Права
  grants: (key) => api.get(`/kb/spaces/${key}/grants`),
  addGrant: (key, subjectType, subjectId, level) =>
    api.post(`/kb/spaces/${key}/grants`, {
      subject_type: subjectType,
      subject_id: subjectId,
      level,
    }),
  removeGrant: (key, grantId) => api.delete(`/kb/spaces/${key}/grants/${grantId}`),

  // Статьи
  page: (id) => api.get(`/kb/pages/${id}`),
  createPage: (data) => api.post('/kb/pages', data),
  updatePage: (id, data) => api.patch(`/kb/pages/${id}`, data),
  submit: (id) => api.post(`/kb/pages/${id}/submit`),
  publish: (id) => api.post(`/kb/pages/${id}/publish`),
  review: (id, revisionId, decision, comment = '') =>
    api.post(`/kb/pages/${id}/review`, {
      revision_id: revisionId,
      decision,
      comment,
    }),
  revisions: (id) => api.get(`/kb/pages/${id}/revisions`),
  revision: (id, revId) => api.get(`/kb/pages/${id}/revisions/${revId}`),
  revert: (id, revisionId) => api.post(`/kb/pages/${id}/revert`, { revision_id: revisionId }),
  archive: (id) => api.post(`/kb/pages/${id}/archive`),
  setLabels: (id, labels) => api.put(`/kb/pages/${id}/labels`, { labels }),

  // Вложения: браузер открывает ссылку сам, минуя axios.
  attachmentUrl: (attId) => `/api/kb/attachments/${attId}`,
  upload: (id, formData) =>
    api.post(`/kb/pages/${id}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  // Личные обновления: решения по моим правкам
  myUpdates: () => api.get('/kb/my-updates'),
  markUpdatesSeen: (revisionIds) =>
    api.post('/kb/my-updates/seen', revisionIds ? { revision_ids: revisionIds } : {}),

  // Модерация и поиск
  reviewQueue: () => api.get('/kb/review-queue'),
  search: (q) => api.get('/kb/search', { params: { q } }),

  // Группы (глобальный админ)
  groups: () => api.get('/admin/kb/groups'),
  createGroup: (data) => api.post('/admin/kb/groups', data),
  updateGroup: (id, data) => api.patch(`/admin/kb/groups/${id}`, data),
  deleteGroup: (id) => api.delete(`/admin/kb/groups/${id}`),
  groupMembers: (id) => api.get(`/admin/kb/groups/${id}/members`),
  addGroupMember: (id, userId) =>
    api.post(`/admin/kb/groups/${id}/members`, { user_id: userId }),
  removeGroupMember: (id, userId) =>
    api.delete(`/admin/kb/groups/${id}/members/${userId}`),
}
